import {Button, Message, Modal, Tooltip} from "@arco-design/web-react";
import ConfigTag from "./ConfigTag/ConfigTag";
import { useContext, useEffect } from "react";
import Title from "../UIComponents/Title/Title";
import MixCutConfigWrapper from "../UIComponents/MixCutConfigWrapper/MixCutConfigWrapper";
import BgConfig from "../BgConfig/BgConfig";
import { ICaption } from "@/stores/mixCutDetailStore/type/caption";
import { mixCutDetailContext } from "../index";
import { observer } from "mobx-react";
import "./VideoConfig.less";
import VoiceConfig from "@/pages/VideoClips/QuickCut/VideoConfig/VoiceConfig/VoiceConfig";
import TextDesc from '@/pages/VideoClips/QuickCut/VideoConfig/TextDesc/index'
import TemplateConfig from '@/pages/VideoClips/QuickCut/VideoConfig/TemplateConfig/index'
import SpecialEffects from '@/pages/VideoClips/QuickCut/VideoConfig/SpecialEffects/index'
interface IVideoConfigProps {
  CationConfig: ICaption[][];
  videoConfigActiveIndex: number;
  handleVideoConfigActiveIndexChange: (e: number) => void;
  activeType?: number;
}
import QuickStore from '@/stores/quickCutStore'
import refeseImg from "@/assets/cut-mix-detail/refese.png";
const VideoConfig: React.FC<IVideoConfigProps> = observer((props) => {
  const { videoConfigActiveIndex, handleVideoConfigActiveIndexChange, activeType } =
    props;
  const { settings } = QuickStore.quickcutData;
  const { videoGroupActive, setVideoGroupActive } =
    useContext(mixCutDetailContext);
  return (
    <MixCutConfigWrapper
      style={{
        boxSizing: "border-box",
        width: 510,
        minWidth: 510,
        borderTop: "none",
        borderLeft: "none",
        borderRight: "none",
        height: "calc(100vh - 84px)",
        paddingTop: "0px",
        overflow: "auto",
      }}>
      <div
        className="video-config-header"
        style={{
          position: "sticky",
          top: 0,
          zIndex: 101,
          background: "white",
          paddingTop: "12px",
        }}>
        <div className="config-header">
          <Title
            title={"视频配置"}
            desc={"设置视频各分镜的配置属性"}
          />
        </div>
        <div>
          <ConfigTag
            videoActiveIndex={videoGroupActive}
            activeKey={videoConfigActiveIndex}
            handleActiveIndexChange={(e) => {
              handleVideoConfigActiveIndexChange(e);
            }}
          />
        </div>
      </div>
      {
        videoConfigActiveIndex === 1 && ((activeType === 2 && !QuickStore.quickcutData.global) || QuickStore.quickcutData.global) && <TextDesc activeIndex={videoGroupActive} />
      }
      {videoConfigActiveIndex === 1 && ((activeType === 2 && !QuickStore.quickcutData.global) || QuickStore.quickcutData.global) ? (
        <VoiceConfig
          emitTimbreSelector={(e) => {
            // todo
          }}
          style={{ marginTop: 12 }}
          speaker={settings.copy.voice.speaker.map((item) => item.speaker_id)}
          speedValue={settings.copy.voice.speed_ratio}
          pitchValue={settings.copy.voice.pitch_ratio}
          speekerId={''}
          volume={settings.copy.voice.volume_ratio}
          handleSpeedValueChange={(e) => {
            settings.copy.voice.speed_ratio = e;
          }}
          handlePitchValueChange={(e) => {
            settings.copy.voice.pitch_ratio = e;
          }}
          handleSpeekerIdChange={(
            e,
            name,
            rate,
            platform,
            lang,
            gender,
            type
          ) => {
            const speakers = settings.copy.voice.speaker;
            const index = speakers.findIndex(item => item.speaker_id === e);
            if (index > -1) {
              speakers.splice(index, 1);
            } else {
              speakers.push({
                "speaker_name": name,
                "speaker_id": e,
                "default_speed_rate": rate,
                "emotion": "",
                "type": type,
                "lang": lang,
                "platform": platform,
                "gender": gender
              });
              const firstLang = speakers[0].lang;
              const hasDifferentLangs = speakers.some(speaker => speaker.lang !== firstLang);
              if (hasDifferentLangs) {
                Message.warning('已选择多语种配音，请确认文案内容是否匹配当前语种')
              }
            }
          }}
          handleVolumeChange={(e) => {
            settings.copy.voice.volume_ratio = e;
          }}
        />
      ) : (
        <></>
      )}
      {
        videoConfigActiveIndex === 1 && (( [1,3].includes(activeType) && !QuickStore.quickcutData.global)) && <div className={'global-info'}>
          片头片尾不参与分镜配置
        </div>
      }
      {
        videoConfigActiveIndex === 2 && <TemplateConfig />
      }
      {videoConfigActiveIndex === 3 ? <BgConfig /> : <></>}
      {videoConfigActiveIndex === 4 ? <SpecialEffects /> : <></>}
    </MixCutConfigWrapper>
  );
});

export default VideoConfig;
